import api from './index';
//
let exports = {};

// 商品换货原因列表
exports.getGoodsExchgCauseList = function (postData, callback) {// 商品换货原因列表
    api.post('/goodsOper/esxchg/cause/list/get')
    .data(postData)
    .done(callback)
    .go();
};

// 商品退货原因列表
exports.getGoodsReturnCauseList = function (postData, callback) {// 商品退货原因列表
    api.post('/goodsOper/return/cause/list/get')
    .data(postData)
    .done(callback)
    .go();
};

//
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/goodsOper.js
// module id = 216
// module chunks = 0